module.exports = __webpack_public_path__ + "html/section-horizontal-text-video_c0a4c2053e3b024246379e2fd8f78cc9.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-horizontal-text-video.html
// module id = RgMP
// module chunks = 61